import createRequest from "@/utils/request"

/**
 * 获取系统枚举
 */
const getEnum = () => createRequest("SDL_URL").get("/common/enum")

/**
 * 获取系统版本
 */
const getVersion = () => createRequest("SDL_URL").get("/common/config/global")
/**
 * 上传文件
 */
const uploadFile = async (file: any, onProgress: (evt: any) => void) => {
    const formData = new FormData()
    formData.append("file", file)
    return await createRequest("SDL_URL", false, {
        onUploadProgress: onProgress
    }).post("/common/upload-file", formData)
}

/**
 * 获取用户角色
 */
const getUserRoles = (payload: any) =>
    createRequest("SDL_URL").get("/common/user-roles", { params: payload })

export default {
    getEnum,
    getVersion,
    uploadFile,
    getUserRoles
}
